import "./styles/base.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { LoginScreen } from "@platform/features";

function App() {
  return <LoginScreen />;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);